export default "__VITE_ASSET__6a1212a4__"